import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { ImagePreviewSemantic_getInstance2vyufepdkqnqf as ImagePreviewSemantic_getInstance } from '../../theming/files.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  renderAttachmentImagegfmiopcjvyci as renderAttachmentImage,
  LocalFileyitm5ua4ch17 as LocalFile,
  renderAttachmentImage20glz1emw24de as renderAttachmentImage_0,
  RemoteFileu6zpetu3ge6n as RemoteFile,
  RemoteAttachment3uyi4s0lht7h0 as RemoteAttachment,
} from './attachmentFilePreview.mjs';
import {
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance,
  ImageLocal23zvpfzvp93up as ImageLocal,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { align1ejncrrer3meh as align } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  HeaderSemantic_getInstance39z1p9hszg7wp as HeaderSemantic_getInstance,
  get_H3Semantic2xvwj5aimpbn as get_H3Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  title1ahgushtajx2d as title,
} from '../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  substringAfterLastuw9v7gfiiihe as substringAfterLast,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  mimeType31eog9gy5012s as mimeType,
  fileName15g5pzin3s3wj as fileName,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { themeFromLast2to6pl6235w33 as themeFromLast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import {
  _ServerFile___init__impl__jj3mn23p0pea18kbfe7 as _ServerFile___init__impl__jj3mn2,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { ProjectAttachmentv4m5lkl2nz8g as ProjectAttachment } from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { openLinkrw9xacx95k0e as openLink } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../nav/crowpay.mjs';
import { ImagePreview2jehuxn8wua45 as ImagePreview } from '../../dialogs/ImagePreview.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function rotateToStart(_this__u8e3s4, item) {
  var index = _this__u8e3s4.s1(item);
  return !(index === -1) ? plus(_this__u8e3s4.m3(index, _this__u8e3s4.p1()), _this__u8e3s4.m3(0, index)) : _this__u8e3s4;
}
function renderAttachment(_this__u8e3s4, attachment, files, width, height) {
  height = height === VOID ? width : height;
  var tmp = _this__u8e3s4.ibb(_this__u8e3s4.ibb(sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, width, height), _this__u8e3s4.hbb(ImagePreviewSemantic_getInstance())), get_unpadded(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp_0 = get_unpadded(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  renderAttachmentImage(view_0, attachment);
  var tmp_1 = align(view_0, Align_Stretch_getInstance(), Align_End_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.card' call
  var tmp$ret$0 = view_0.hbb(CardSemantic_getInstance());
  var tmp_2 = view_0.ibb(tmp_1, tmp$ret$0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
  view_1.hba(view_1.kba().ib0_1.ed0(4));
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_shown_$ref_kipsub(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_3, tmp_4, TextView$_set_shown_$ref_l7jsq9(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = $this$reactiveScope.baj(attachment).k20();
    var tmp$ret$2 = !isBlank(this_1);
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  view_1.bbs(Align_Center_getInstance());
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$4 = $this$reactiveScope.baj(attachment).k20();
    this_1.set(tmp$ret$4);
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_2, view_1);
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  onClick(view, VOID, VOID, renderAttachment$slambda_0(attachment, files, view));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function renderFiles(_this__u8e3s4, files, size) {
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, size);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = RowOrCol$_get_shown_$ref_m8lfse(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, RowOrCol$_set_shown_$ref_7290m6(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$1 = !$this$reactiveScope.baj(files).i1();
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  forEachUpdating(view_0, files, VOID, ($this$forEachUpdating, attachment) => {
    renderAttachment($this$forEachUpdating, attachment, files, size);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  var tmp_2 = view.ibb(colored(view, AppColors_getInstance().ffz_1.yg9_1), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.h3' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(HeaderSemantic_getInstance().ybe(get_H3Semantic())));
  view_1.hb7(false);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_shown_$ref_kipsub_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('shown', 0, tmp_3, tmp_4, TextView$_set_shown_$ref_l7jsq9_0(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$7 = $this$reactiveScope.baj(files).i1();
    this_1.set(tmp$ret$7);
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'No Files';
  var tmp_5 = view_1.tb5_1;
  var tmp_6;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_6 = '\xA0';
  } else {
    tmp_6 = value;
  }
  tmp_5.fbu(tmp_6);
  view.fbb(p_1, view_1);
  view.jbb(tmp_2, view_1);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function renderFilePreview(_this__u8e3s4, filePreview, size) {
  if (filePreview instanceof RemoteAttachment()) {
    renderAttachmentImage_0(_this__u8e3s4, filePreview.sgb_1);
  } else {
    if (filePreview instanceof RemoteFile()) {
      renderAttachmentImage_0(_this__u8e3s4, new (ProjectAttachment())('', 'image/*', _ServerFile___init__impl__jj3mn2(filePreview.ugb_1)));
    } else {
      if (filePreview instanceof LocalFile()) {
        var mimeType_0 = mimeType(filePreview.igb_1);
        if (startsWith(mimeType_0, 'image')) {
          // Inline function 'com.lightningkite.kiteui.views.direct.image' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (ImageView())(_this__u8e3s4);
          this_0.pda(ImageScaleType_Fit_getInstance());
          this_0.oda(new (ImageLocal())(filePreview.igb_1));
          this_0.zba();
        } else {
          var tmp = get_centered(_this__u8e3s4);
          _this__u8e3s4.jbb(tmp, title(_this__u8e3s4, ($this$title) => {
            var tmp = KMutableProperty0();
            var tmp_0 = TextView$_get_content_$ref_4pzcwl_0($this$title);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0($this$title));
            reactiveScope($this$title, ($this$reactiveScope) => {
              // Inline function 'kotlin.text.uppercase' call
              // Inline function 'kotlin.js.asDynamic' call
              var tmp$ret$6 = substringAfterLast(fileName(filePreview.igb_1), '.').toUpperCase();
              this_0.set(tmp$ret$6);
              return Unit_instance;
            });
            return Unit_instance;
          }));
        }
        var tmp_0 = themeFromLast(_this__u8e3s4, renderFilePreview$lambda);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        var tmp_1 = KMutableProperty0();
        var tmp_2 = Frame$_get_shown_$ref_dnks5k(view);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('shown', 0, tmp_1, tmp_2, Frame$_set_shown_$ref_s2otf0(view));
        reactiveScope(view, ($this$reactiveScope) => {
          var tmp$ret$8 = $this$reactiveScope.baj($this$reactiveScope.baj(filePreview.vgb())) == null;
          this_1.set(tmp$ret$8);
          return Unit_instance;
        });
        var tmp_3 = get_centered(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (ActivityIndicator())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view.fbb(p_0, view_0);
        view.jbb(tmp_3, view_0);
        _this__u8e3s4.fbb(p, view);
        _this__u8e3s4.jbb(tmp_0, view);
        var tmp_4 = themeFromLast(_this__u8e3s4, renderFilePreview$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs_1 = _this__u8e3s4.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
        _this__u8e3s4.ebb(p_1, view_1);
        view_1.hb7(false);
        var tmp_5 = KMutableProperty0();
        var tmp_6 = Frame$_get_shown_$ref_dnks5k_0(view_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('shown', 0, tmp_5, tmp_6, Frame$_set_shown_$ref_s2otf0_0(view_1));
        reactiveScope(view_1, ($this$reactiveScope) => {
          var tmp$ret$16 = $this$reactiveScope.baj($this$reactiveScope.baj(filePreview.vgb())) === false;
          this_2.set(tmp$ret$16);
          return Unit_instance;
        });
        var tmp_7 = get_centered(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        var tmp_8 = get_centered(view_2);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'Upload Failed';
        var tmp_9 = view_3.tb5_1;
        var tmp_10;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_10 = '\xA0';
        } else {
          tmp_10 = value;
        }
        tmp_9.fbu(tmp_10);
        view_2.fbb(p_3, view_3);
        view_2.jbb(tmp_8, view_3);
        var tmp_11 = get_centered(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.ebb(p_4, view_4);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.ebb(p_5, view_5);
        view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_0 = 'Try Again';
        var tmp_12 = view_5.tb5_1;
        var tmp_13;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_0) === 0) {
          tmp_13 = '\xA0';
        } else {
          tmp_13 = value_0;
        }
        tmp_12.fbu(tmp_13);
        view_4.fbb(p_5, view_5);
        onClick(view_4, VOID, VOID, renderFilePreview$slambda_0(filePreview));
        view_2.fbb(p_4, view_4);
        view_2.jbb(tmp_11, view_4);
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_7, view_2);
        _this__u8e3s4.fbb(p_1, view_1);
        _this__u8e3s4.jbb(tmp_4, view_1);
      } else {
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs_6 = _this__u8e3s4.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? _this__u8e3s4 : tmp0_elvis_lhs_6;
        _this__u8e3s4.ebb(p_6, view_6);
        _this__u8e3s4.fbb(p_6, view_6);
      }
    }
  }
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = await_0($this.pge_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var a = tmp;
  if (startsWith(a.f93(), 'image')) {
    var tmp_0 = get_dialogStack();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.qge_1;
    var tmp_1 = await_0(this_0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$0 = tmp_1;
    tmp_0.xgd(new (ImagePreview())(rotateToStart(tmp$ret$0, a)));
  } else {
    openLink($this.rge_1.pc(), _ServerFile___get_location__impl__ddyqaq(a.g93()));
  }
  return Unit_instance;
}
var renderAttachment$slambdaClass;
function renderAttachment$slambda() {
  if (renderAttachment$slambdaClass === VOID) {
    class $ {
      constructor($attachment, $files, $$this$button) {
        this.pge_1 = $attachment;
        this.qge_1 = $files;
        this.rge_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderAttachment$slambdaClass = $;
  }
  return renderAttachment$slambdaClass;
}
function renderAttachment$slambda_0($attachment, $files, $$this$button) {
  var i = new (renderAttachment$slambda())($attachment, $files, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_shown_$ref_kipsub_0(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9_0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderFilePreview$lambda(it) {
  return it.wd1(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it.ob0_1.bb2().fcz(0.4).hcz(0.4));
}
function Frame$_get_shown_$ref_dnks5k(p0) {
  return () => p0.wb8();
}
function Frame$_set_shown_$ref_s2otf0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function renderFilePreview$lambda_0(it) {
  var tmp0_background = it.ob0_1.bb2().fcz(0.4).hcz(0.8);
  var tmp1_outlineWidth = get_px(0);
  var tmp2_body = it.eb0_1.td4(VOID, VOID, true);
  var tmp3_foreground = AppColors_getInstance().hfz_1.yg9_1;
  return it.wd1(VOID, VOID, tmp2_body, VOID, VOID, VOID, VOID, tmp3_foreground, VOID, VOID, tmp1_outlineWidth, tmp0_background);
}
function Frame$_get_shown_$ref_dnks5k_0(p0) {
  return () => p0.wb8();
}
function Frame$_set_shown_$ref_s2otf0_0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  $this.sge_1.f52();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.sge_1.xgb(LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().mff_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.tge_1 = p0;
      }
      sao($completion) {
        return this.tge_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ContractorLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
var renderFilePreview$slambdaClass;
function renderFilePreview$slambda() {
  if (renderFilePreview$slambdaClass === VOID) {
    class $ {
      constructor($filePreview) {
        this.sge_1 = $filePreview;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderFilePreview$slambdaClass = $;
  }
  return renderFilePreview$slambdaClass;
}
function renderFilePreview$slambda_0($filePreview) {
  var i = new (renderFilePreview$slambda())($filePreview);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  renderAttachment as renderAttachment65kt96l4h4c9,
  renderFilePreview as renderFilePreview3fl8uuiu4tdzl,
  renderFiles as renderFiles2vz7gmubfqcvp,
};
//endregion

//# sourceMappingURL=renderFiles.mjs.map
